import React, { useCallback, useEffect } from 'react'
import { Box } from './Styled'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../../model/rootReducer'
import { Button, Space } from 'antd'
import { useState } from 'react'
import GraphForms from './monitoringForms/GraphForms'
import { CSVLink } from 'react-csv'
import {
  getEventsAction,
  getMonitoringGraphAction,
} from '../../../../business/actions/monitoringGraphActions'
import moment from 'moment'
import { MonitoringGraphOptions } from '../../../../model/monitoringGraph/types'
import { toDatePicker } from '../../../../helpers/dateFormatHelper'

type MonitoringGraphProps = {
  exportImage: () => void
  setPercentage: (percentageRange: number[]) => void
}

const MonitoringGraphPanel: React.FunctionComponent<MonitoringGraphProps> = ({
  exportImage,
  setPercentage,
}) => {
  const dispatch = useDispatch()
  const [csv, setCSV] = useState(``)
  const [options, setOptions] = useState({
    startDate: moment(),
    endDate: moment(),
    events: '',
    actions: '',
    graphGenerated: false,
    selectedActions: [],
  })
  const selectedBotId = useSelector((state: RootState) => state.bot.selectedBot)
  const graphData = useSelector(
    (state: RootState) => state.monitoringGraph.graph
  )

  useEffect(() => {
    if (selectedBotId) {
      dispatch(getEventsAction.request(null))
    }
  }, [selectedBotId])

  useEffect(() => {
    if (options.graphGenerated) {
      const dateFormat = 'YYYY-MM-DD'
      dispatch(
        getMonitoringGraphAction.request(
            new MonitoringGraphOptions(
            toDatePicker(options.startDate),
            toDatePicker(options.endDate),
            options.events,
            options.actions
          )
        )
      )
    }
  }, [options])

  useEffect(() => {
    var csvData = `conversation ID`
    graphData.conversationsId.forEach((conversationId) => {
      csvData += '\n' + conversationId
    })
    setCSV(csvData)
  }, [graphData.conversationsId])

  const generateGraph = useCallback(
    (selectedFilters) => {
      var startDate = selectedFilters.dateRange[0]
      var endDate = selectedFilters.dateRange[1]
      var events = ''
      selectedFilters.events.forEach((element: any) => {
        events += ';' + element
      })
      setPercentage(selectedFilters.percentageRange)
      setOptions({
        startDate,
        endDate,
        events,
        actions: '',
        graphGenerated: true,
        selectedActions: [],
      })
    },
    [options]
  )

  const updateGraph = useCallback(() => {
    var actions = ''
    options.selectedActions.forEach((element: any) => {
      actions = actions + ';' + element
    })
    setOptions({ ...options, actions })
  }, [options])

  const ExportGraph = () => {
    return (
      <Box>
        <Space>
          <Button type="primary" onClick={exportImage}>
            Exporter une image
          </Button>
          <CSVLink data={csv} separator=";" filename="monitoringGraph.csv">
            <Button type="primary">Exporter un CSV</Button>
          </CSVLink>
        </Space>
      </Box>
    )
  }

  return (
    <div>
      <GraphForms
        generateGraph={generateGraph}
        updateGraph={updateGraph}
        selectedActions={options.selectedActions}
      />
      {graphData.availableActions.length > 0 && <ExportGraph />}
    </div>
  )
}
export default MonitoringGraphPanel
